import axios from 'axios'

import type { ChartClickRequest, ChartClickResponse } from './types'

export class TextAnalyticsChartApi {
	private readonly endpoints: { click: string; data: string }

	constructor(endpoints: { click: string; data: string }) {
		this.endpoints = endpoints
	}

	async click(params: ChartClickRequest): Promise<ChartClickResponse> {
		const { data } = await axios.post<ChartClickResponse>(this.endpoints.click, params)
		return data
	}
}
